<template>
  <div>
    <p>Welcome to the experiment. This experiment will last around 15 minutes. Press <strong>enter</strong> to begin.</p>
  </div>
</template>

<script>
import * as Mousetrap from 'mousetrap'
import * as _ from 'lodash'
export default {
  mounted () {
    // bind handler to the enter key
    Mousetrap.bind('enter', _.once(() => {
      // go to the first instructions page
      this.$router.replace('/instructions/1')
    }))
  },
  beforeDestroy () {
    // remove handler from enter key
    Mousetrap.unbind('enter')
  }
}
</script>
